$(() => {
    const root = $(".js-tab-filter");
    if (root.length) {
        root.find(".js-tab-filter-button").click((e) => {
            const $btn = $(e.currentTarget);
            root.find(".js-tab-filter-button.active").removeClass("active");
            const desiredCategory = $btn.addClass("active").data("filter-category") + "";
            const items = $(".filter-item");

            if (desiredCategory == "all") {
                items.show();
            } else {
                items.each((_, elem) => {
                    const cat = $(elem).data("filter-category") + "";
                    if (cat) {
                        const catArray = cat.split(",");
                        if (catArray.indexOf(desiredCategory) >= 0) {
                            $(elem).show();
                        } else {
                            $(elem).hide();
                        }
                    }
                });
            }
        });
    }

    $(".blog-filter .nav-link, .prize-table .nav-link").click(function (e) {
        if (window.matchMedia("(max-width: 896px)").matches) {
            const $container = $(e.currentTarget).closest(".tab-filter-container");

            if ($(e.currentTarget).hasClass("active")) {
                e.preventDefault();
                const heightArray = [];
                let combinedHeight;

                if ($container.hasClass("active")) {
                    $container.addClass("hiding").removeClass("active");
                    setTimeout(() => {
                        $container.removeClass("hiding");
                    }, 300);
                } else {
                    $container.addClass("active");

                    $container.find(".nav-item:not(.activated)").each(function () {
                        heightArray.push(parseFloat($(this).css("height")));
                    });

                    // Calculate dynamic height of items in tabs
                    combinedHeight = heightArray.reduce((a, b) => a + b, 0);
                    $container.find(".nav-tabs").css({
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        "--tab-height": ` ${combinedHeight}px`,
                    }); /* eslint-disable-line @typescript-eslint/naming-convention */
                }
            } else {
                $container.removeClass("active").addClass("hiding");
                setTimeout(() => {
                    $container.removeClass("hiding");
                }, 300);
            }
        }
    });

    $(".js-tab-filter .js-tab-filter-button").click(function (e) {
        if (window.matchMedia("(max-width: 540px)").matches) {
            const $container = $(e.currentTarget).closest(".js-tab-filter-container");

            if ($(e.currentTarget).hasClass("active")) {
                e.preventDefault();
                if ($container.hasClass("active")) {
                    $container.addClass("hiding").removeClass("active");
                    setTimeout(() => {
                        $container.removeClass("hiding");
                    }, 300);
                } else {
                    $container.addClass("active");
                }
            } else {
                $container.removeClass("active").addClass("hiding");
                setTimeout(() => {
                    $container.removeClass("hiding");
                }, 300);
            }
        }
    });
});
